module.exports = __webpack_public_path__ + "static/media/gift-image.5a68ec02.png";